// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8826) return "static/chunks/8826-b9158a6132a123ad.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1475":"fdfbbdd8","4106":"b9633c63"}[chunkId] || chunkId) + "." + {"1475":"611c8f4fb9cbb180","3011":"074d61bbdbe4f770","4046":"43c34c9a04278636","4106":"430eae371c711fda","6992":"d7dc3ee189e9d6a1","7039":"47aa7b19ab7481cc","8262":"ab18ad7f1d426688"}[chunkId] + ".js";
};